export default __webpack_public_path__ + "static/kv-logo-m-kr-95272ba0d8f964f1d4772b8a01f71baf.png";